import { useEffect } from 'react';
import { useNavegate } from 'App/hooks';
import { configurationsRoutes } from 'domains/Configurations';
import {
  useGetDomainsQuery,
  useGetActiveDomainOrderQuery,
} from 'domains/Configurations/Domains/domainsApi';
import { useHasNuvemDomainEnabled } from 'domains/Configurations/Domains/hooks';
import { DOMAIN_ORDER_REDIRECT_TO_DETAILS_STATUSES } from '../../../constants';

export function useDomainsRedirectLogic() {
  const { goTo } = useNavegate();
  const hasNuvemDomainEnabled = useHasNuvemDomainEnabled();

  const shouldRedirectDueToDisabled = !hasNuvemDomainEnabled;
  const shouldFetchData = hasNuvemDomainEnabled;

  const { data: domainsData, isLoading: isLoadingDomains } = useGetDomainsQuery(
    undefined,
    { skip: !shouldFetchData },
  );

  const { data: activeOrder, isLoading: isLoadingActiveOrder } =
    useGetActiveDomainOrderQuery(undefined, { skip: !shouldFetchData });

  const hasCustomDomains =
    shouldFetchData &&
    !isLoadingDomains &&
    domainsData &&
    domainsData.some((domain) => !domain.isOurDomain);

  const shouldRedirectToOrderDetails =
    shouldFetchData &&
    !isLoadingActiveOrder &&
    activeOrder &&
    DOMAIN_ORDER_REDIRECT_TO_DETAILS_STATUSES.includes(activeOrder.status);

  const shouldRedirectToList = shouldRedirectDueToDisabled || hasCustomDomains;

  const isLoading =
    shouldRedirectToList ||
    (shouldFetchData && (isLoadingDomains || isLoadingActiveOrder));

  useEffect(() => {
    if (shouldRedirectToList) {
      goTo(configurationsRoutes.domainsList);
    } else if (shouldRedirectToOrderDetails && activeOrder) {
      goTo(
        configurationsRoutes.domainsOrder.replace(
          ':payOrderId',
          activeOrder.payOrderId,
        ),
      );
    }
  }, [shouldRedirectToList, shouldRedirectToOrderDetails, activeOrder, goTo]);

  const ourDomain =
    domainsData?.find((domain) => domain.isOurDomain)?.name ?? '';

  return { isLoading, ourDomain };
}
